<div class="audit-detail">
  <div class="container-fluid">
    <div class="row audit-detail-header-container">
      <h3 class="audit-detail-header">
        <ng-container [ngSwitch]="audit.action">
          <span *ngSwitchCase="'Delete'">Deleted</span>
          <span *ngSwitchCase="'Insert'">Created</span>
          <span *ngSwitchCase="'Update'">Updated</span>
        </ng-container>
        <span *ngIf="audit.performedBy"> by {{ audit.performedBy }}</span>
        <span *ngIf="audit.time"> on {{ audit.time | momentDate : 'MM/DD/YYYY HH:mm UTC' }}</span>
      </h3>
    </div>
    <ng-container *ngFor="let field of audit.fields">
      <div class="row">
        <div class="col">{{ field.name }}</div>
        <div class="col">{{ field.oldValue }}</div>
        <div class="col">⟹</div>
        <div class="col">{{ field.newValue }}</div>
      </div>
    </ng-container>
  </div>
</div>
